module.exports = __webpack_public_path__ + "img/BBireme64_ua.de6c7a21.webp";